import { render } from "./NotificationSetting.vue?vue&type=template&id=6c4a7a69&scoped=true"
import script from "./NotificationSetting.vue?vue&type=script&lang=js"
export * from "./NotificationSetting.vue?vue&type=script&lang=js"

import "./NotificationSetting.vue?vue&type=style&index=0&id=6c4a7a69&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4a7a69"]])

export default __exports__